import { useGetFarms, useUserContext } from "utils";

/**
 * Moves the user off a farm that was just deleted: the first remaining farm becomes the active one, or the stored
 * farm is cleared when none is left. Returns whether the active farm changed, so the caller can leave the page.
 */
export const useSwitchFromDeletedFarm = (activeFarmId: string | null | undefined) => {
  const { data: farms } = useGetFarms();
  const { switchFarm, reloadUserData } = useUserContext();

  return (deletedFarmId: string): boolean => {
    if (deletedFarmId !== activeFarmId) return false;

    // the farms list still holds the deleted farm until it is refetched
    const remaining = farms.filter((farm) => farm.id !== deletedFarmId);
    switchFarm(remaining[0]?.id ?? null);
    reloadUserData();
    return true;
  };
};
